import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../firebase'; // Adjust the path as needed

const DeleteUser = ({ open, onClose, userId, onDelete, onSuccess }) => {
  const handleDelete = async () => {
    try {
      // Create a reference to the user document in Firestore
      const userDocRef = doc(db, 'employees', userId);

      // Delete the document
      await deleteDoc(userDocRef);

      // Notify parent component about success
      onSuccess();
      onDelete(); // Optionally call onDelete if needed

    } catch (error) {
      console.error('Error deleting user:', error);
      // Optionally handle the error (e.g., show a notification)
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to remove this employee?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleDelete} color="error" variant="contained">Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUser;
